import { render, staticRenderFns } from "./JagfxJob.vue?vue&type=template&id=6d4051a2&"
import script from "./JagfxJob.vue?vue&type=script&lang=js&"
export * from "./JagfxJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports